// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZhihuSquareFilledSvg from "@fishx/icons-svg/es/asn/ZhihuSquareFilled";
import FishxIcon from '../components/FishxIcon';

var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuSquareFilledSvg
  }));
};

ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
export default React.forwardRef(ZhihuSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ZhihuSquareFilled.js
// module id = 4427
// module chunks = 0